import React from "react";
import { Box } from "@chakra-ui/react";
import { SearchBox } from "react-instantsearch";
import { SearchIcon } from "ui/icons";

type AlgoliaSearchInputProps = {
  placeholder?: string;
};

export function AlgoliaSearchInput({ placeholder = "Search..." }: AlgoliaSearchInputProps) {
  return (
    <Box position="relative" bg="white">
      <SearchIcon
        position="absolute"
        boxSize={5}
        zIndex={200}
        top="50%"
        transform="translateY(-50%)"
        left={4}
        pointerEvents="none"
        color="gray.400"
      />
      <SearchBox autoFocus placeholder={placeholder} />
    </Box>
  );
}
